<template>
  <MRow :gutter="28">
    <MCol>
      <MRow :gutter="0">
        <MCol
          class="border-neutral-lighter border-b border-solid border-t-0 border-r-0 border-l-0"
        >
          <h6 class="text-primary font-normal">{{ $t('other_info') }}</h6>
        </MCol>
      </MRow>
      <slot name="before"></slot>
      <MRow
        v-if="!allowedFields || allowedFields.indexOf('referenceNumber') >= 0"
        class="my-3"
      >
        <MCol class="material-input">
          <div>
            <small class="text-neutral-light">
              {{ $tc('reference') }} {{ $tc('number') }}
            </small>
          </div>
          <div id="reference-num" class="ant-input">
            {{ value.referenceNumber || '---' }}
          </div>
        </MCol>
      </MRow>
      <MRow
        v-if="!allowedFields || allowedFields.indexOf('closedDate') >= 0"
        class="my-3"
      >
        <MCol>
          <div>
            <small class="text-neutral-light">
              {{ $tc('closed_date') }}
            </small>
          </div>
          <div v-if="value.closedDate" id="closed-at">
            {{ value.closedDate | datetime }}
          </div>
          <div v-else>---</div>
        </MCol>
      </MRow>
      <MDivider class="mt-2 mb-0" />
      <MRow
        v-if="!allowedFields || allowedFields.indexOf('updatedTime') >= 0"
        class="my-3"
      >
        <MCol>
          <div>
            <small class="text-neutral-light">
              {{ $tc('last_updated_date') }}
            </small>
          </div>
          <div id="updated-at">
            {{ value.updatedTime | datetime }}
          </div>
          <div id="updated-at"> ({{ value.updatedTime | timeago }}) </div>
        </MCol>
      </MRow>
      <MDivider class="mt-2 mb-0" />
      <MRow
        v-if="!allowedFields || allowedFields.indexOf('assetType') >= 0"
        class="my-3"
      >
        <MCol class="material-input">
          <div>
            <small class="text-neutral-light">
              {{ $tc('asset_type') }}
            </small>
          </div>
          <div id="call-from" class="ant-input">
            <!-- {{ value.assetType }} -->
            {{
              value.assetType
                ? (assetTypeOption.find((o) => o.key === value.assetType) || {})
                    .text
                : '---'
            }}
          </div>
        </MCol>
      </MRow>
      <MRow
        v-if="
          isApproval === true &&
          approvalStage !== undefined &&
          value.returnableType === 'temporary_transfer'
        "
        class="my-3"
      >
        <MCol class="material-input">
          <div>
            <small class="text-neutral-light">
              {{ $tc('approval') }} {{ $tc('stage') }}
            </small>
          </div>
          <div id="call-from" class="ant-input">
            {{ approvalStage }}
          </div>
        </MCol>
      </MRow>
    </MCol>
  </MRow>
</template>

<script>
import { assetTypeOptions } from '@modules/asset-management/helpers/option-map'
import { authComputed } from '@state/modules/auth'
import { StatusComputed } from '@/src/state/modules/status'
export default {
  name: 'Sidebar',
  model: {
    event: 'change',
  },
  props: {
    value: { type: Object, required: true },
    moduleName: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    allowedFields: { type: Array, default: undefined },
    changeStage: { type: String, default: undefined },
    isApproval: { type: Boolean, default: false },
  },
  data() {
    this.assetTypeOption = assetTypeOptions()
    return {}
  },
  computed: {
    ...authComputed,
    ...StatusComputed,
    approvalStage() {
      let assetMovementOptions = this[`${this.moduleName}Status`]
      const assetMovement = (
        assetMovementOptions.filter(
          (f) => f.key === this.value.approvalAskOnStatusId
        )[0] || {}
      ).stage
      return this.value.movementType === 'asset_transfer'
        ? this.$tc(assetMovement)
        : undefined
    },
  },
  methods: {
    handleChange(change) {
      this.$emit('change', change)
    },
  },
}
</script>

<style lang="less" scoped>
.bordered-bottom {
  @apply border-solid border-neutral-lighter border-b border-t-0 border-l-0 border-r-0;
}
</style>
